import React from 'react';
import clsx from 'clsx';
import styles from './UIGamePlayerInfoSectionContent.module.scss';
import { CardEnum } from '@colonist/game-states';
import { UIGameCard } from '../../../../../common/UIGameCard/index.ts';
import { UIGamePlayerInfoSectionImageWithCount } from '../../UIGamePlayerInfoSectionImageWithCount/UIGamePlayerInfoSectionImageWithCount.tsx';
import IconLargestArmy from '@static/images/icon_largest_army.svg';
import IconLargestArmyHighlight from '@static/images/icon_largest_army_highlight.svg';
import IconDefenderOfColonist from '@static/images/icon_swords.svg';
import IconDefenderOfColonistHighlight from '@static/images/icon_swords_highlight.svg';
import IconLongestRoad from '@static/images/icon_longest_road.svg';
import IconLongestRoadHighlight from '@static/images/icon_longest_road_highlight.svg';
import { TooltipResourceCards } from './TooltipResourceCards.tsx';
import { T, Tooltip } from '@colonist/ui';
import { useUIGameTranslationContext } from '../../../../../contexts/UIGameTranslationContext.tsx';
export const UIGamePlayerInfoSectionContentHand = ({ resourceCardCount, resourceCardDiscardLimit, developmentCardCount, progressCardCount, largestArmyCount, highlightLargestArmy, defenderOfColonistCount, highlightDefenderOfColonist, longestRoadCount, highlightLongestRoad })=>{
    const isResourceCardCountOverLimit = resourceCardCount > resourceCardDiscardLimit;
    const resourceCardEnum = isResourceCardCountOverLimit ? CardEnum.ResourceOverLimit : CardEnum.AnyResource;
    const largestArmyIcon = highlightLargestArmy ? IconLargestArmyHighlight : IconLargestArmy;
    const defenderOfColonistIcon = highlightDefenderOfColonist ? IconDefenderOfColonistHighlight : IconDefenderOfColonist;
    const longestRoadIcon = highlightLongestRoad ? IconLongestRoadHighlight : IconLongestRoad;
    const { translationKeyContext } = useUIGameTranslationContext();
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, styles.containerHand)
    }, /*#__PURE__*/ React.createElement("div", {
        "data-resource-card": true
    }, /*#__PURE__*/ React.createElement(TooltipResourceCards, {
        resourceCardDiscardLimit: resourceCardDiscardLimit
    }, /*#__PURE__*/ React.createElement(UIGameCard, {
        cardEnum: resourceCardEnum,
        size: "xs",
        count: resourceCardCount
    }))), developmentCardCount !== undefined && /*#__PURE__*/ React.createElement("div", {
        "data-development-card": true
    }, /*#__PURE__*/ React.createElement(Tooltip, {
        content: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.developmentCard.body"
        }),
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.developmentCard.title"
        })
    }, /*#__PURE__*/ React.createElement(UIGameCard, {
        cardEnum: CardEnum.DevelopmentBack,
        size: "xs",
        count: developmentCardCount
    }))), progressCardCount !== undefined && /*#__PURE__*/ React.createElement("div", {
        "data-development-card": true
    }, /*#__PURE__*/ React.createElement(Tooltip, {
        content: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.progressCard"
        })
    }, /*#__PURE__*/ React.createElement(UIGameCard, {
        cardEnum: CardEnum.ProgressCardBack,
        size: "xs",
        count: progressCardCount
    }))), largestArmyCount !== undefined && /*#__PURE__*/ React.createElement(Tooltip, {
        content: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.largestArmy.body"
        }),
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.largestArmy.title"
        })
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoSectionImageWithCount, {
        piece: largestArmyIcon,
        count: largestArmyCount,
        bold: highlightLargestArmy !== null && highlightLargestArmy !== void 0 ? highlightLargestArmy : false
    })), defenderOfColonistCount !== undefined && /*#__PURE__*/ React.createElement(Tooltip, {
        content: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.knightStrength.body"
        }),
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.knightStrength.title"
        })
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoSectionImageWithCount, {
        piece: defenderOfColonistIcon,
        count: defenderOfColonistCount,
        bold: highlightDefenderOfColonist !== null && highlightDefenderOfColonist !== void 0 ? highlightDefenderOfColonist : false
    })), longestRoadCount !== undefined && /*#__PURE__*/ React.createElement(Tooltip, {
        content: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerInformation.longestRoad.body',
                options: {
                    context: translationKeyContext
                }
            }
        }),
        title: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerInformation.longestRoad.title',
                options: {
                    context: translationKeyContext
                }
            }
        })
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoSectionImageWithCount, {
        piece: longestRoadIcon,
        count: longestRoadCount,
        bold: highlightLongestRoad !== null && highlightLongestRoad !== void 0 ? highlightLongestRoad : false
    })));
};
